import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./TestActivity.scss";
import NoMocktestSvg from "@Assets/svg/Dashboard-svgs/NoMocktest.svg";
import { CardDashboardIndex, SkeletonCardDashboardIndex } from "../Dashboardpage/Components/Cards";
import { getDashboardTestSeriesDetails } from "../Service/Dashboard.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { Card } from 'primereact/card';
import { Paginator } from 'primereact/paginator';
import SvgIcon from "@Components/icons/SvgIcon";
import { useAppDispatch, useAppSelector } from "@Src/app/hooks";
import { getCouresePreferences } from "@Src/features/UserProfile/Services/UserProfile.sevice";
import { setCoursePreferences } from "@Src/app/reducers/auth/coursePreferencesSlice";

export const TestActivityIndex = () => {
  const location = useLocation();
  const [toggletabs, settoggletabs] = useState(location.state?.activeTab ?? 1);
  const [dashdetails, setdashdetails] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const coursePreferences = useAppSelector(state => state.coursePreferences);
  const classId = coursePreferences?.classDetails[0]?.Id;
  const boardId = coursePreferences?.boardDetails[0]?.Id;

  const totalCount = completedCount + pendingCount;

  const togglebutton = (tabs: any) => {
    settoggletabs(tabs);
    setFirst(0);
    dashboardTestSeriesDetails(tabs, 1, rows);
  };

  const onPageChange = (event: any) => {
    setFirst(event.first);
    setRows(event.rows);
    const page = event.page + 1;
    dashboardTestSeriesDetails(toggletabs, page, event.rows);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    dashboardTestSeriesDetails(toggletabs, 1, rows);
    fetchCounts();
  }, [])

  const fetchCounts = () => {
    // Fetch completed count
    getDashboardTestSeriesDetails({ page: 1, limit: 1, status: 1, classId, boardId }).then((res: APIResponse) => {
      if (res.ResponseType === APIStatus.SUCCESS && res.data && res.data.length > 0 && res.data[0].total_record !== undefined) {
        setCompletedCount(res.data[0].total_record);
      }
    });
    // Fetch pending count
    getDashboardTestSeriesDetails({ page: 1, limit: 1, status: 0, classId, boardId }).then((res: APIResponse) => {
      if (res.ResponseType === APIStatus.SUCCESS && res.data && res.data.length > 0 && res.data[0].total_record !== undefined) {
        setPendingCount(res.data[0].total_record);
      }
    });
  }

  const dashboardTestSeriesDetails = (status: number, page: number, limit: number) => {
    setIsLoading(true)
    getDashboardTestSeriesDetails({ page, limit, status, classId, boardId }).then((response: APIResponse) => {
      if (response.ResponseType === APIStatus.SUCCESS) {
        let newTestData = [];
        let total = 0;
        if (response.data && response.data.length > 0 && response.data[0].result_data) {
          newTestData = response.data[0].result_data;
          total = response.data[0].total_record;
        } else if (Array.isArray(response.data)) {
          newTestData = response.data;
          total = response.data.length;
        }
        setdashdetails(newTestData)
        setTotalRecords(total)

        if (status === 1) setCompletedCount(total);
        else setPendingCount(total);

        setIsLoading(false)
      }
    }).catch((error: any) => {
      setIsLoading(false)
      console.log(error)
    })
  }

  const fetchCoursePreferences = async () => {
    try {
      const coursePreferencesResponse = await getCouresePreferences();
      if (coursePreferencesResponse?.ResponseType === APIStatus.SUCCESS && coursePreferencesResponse.data) {
        dispatch(setCoursePreferences(coursePreferencesResponse.data));
      }
    } catch (err) {
      console.error("Failed to fetch course preferences after registration", err);
    }
  }

  useEffect(() => {

    fetchCounts()
    dashboardTestSeriesDetails(toggletabs, 1, rows)
  }, [coursePreferences])

  useEffect(() => {
    fetchCoursePreferences();
  }, [])

  return (
    <div className="test-activity-container">
      <div className="test-activity-header">
        <h1 className="test-activity-title">My Test</h1>
        <p className="test-activity-subtitle">Track your test progress and performance</p>
      </div>

      {/* Statistics Cards */}
      <div className="test-activity-stats">
        <div className="stat-card total">
          <div className="stat-icon">
            <SvgIcon name="mockTest" size={32} />
          </div>
          <div className="stat-content">
            <h2 className="stat-number">{totalCount}</h2>
            <p className="stat-label">Test Attempted</p>
          </div>
        </div>

        <div className="stat-card completed">
          <div className="stat-icon">
            <SvgIcon name="testCompleted" size={32} />
          </div>
          <div className="stat-content">
            <h2 className="stat-number">{completedCount}</h2>
            <p className="stat-label">Completed</p>
          </div>
        </div>

        <div className="stat-card pending">
          <div className="stat-icon">
            <SvgIcon name="testPending" size={32} />
          </div>
          <div className="stat-content">
            <h2 className="stat-number">{pendingCount}</h2>
            <p className="stat-label">Pending</p>
          </div>
        </div>
      </div>

      {/* Test Activity Table */}
      <Card className="test-activity-card">
        <div className="test-activity-content">
          <div className="tw-flex tw-flex-col lg:tw-flex-row tw-gap-4 tw-justify-between tw-items-start lg:tw-items-center mb-4">
            <div className="tw-text-2xl tw-font-bold tw-text-black">
              Test Details
            </div>
            <div className="tw-flex tw-flex-wrap tw-gap-2 tw-w-full lg:tw-w-auto">
              <div className="legend-item tw-flex tw-items-center tw-bg-red-100 tw-px-2 md:tw-px-4 tw-py-1 md:tw-py-2 tw-rounded-lg">
                <span className='tw-font-semibold tw-text-[10px] md:tw-text-sm'><span className="dot dot-poor"></span> {"Score < 30%"}</span>
              </div>
              <div className="legend-item tw-flex tw-items-center tw-bg-orange-100 tw-px-2 md:tw-px-4 tw-py-1 md:tw-py-2 tw-rounded-lg">
                <span className='tw-font-semibold tw-text-[10px] md:tw-text-sm'><span className="dot dot-improving"></span> {"Score 30% - < 50%"}</span>
              </div>
              <div className="legend-item tw-flex tw-items-center tw-bg-yellow-100 tw-px-2 md:tw-px-4 tw-py-1 md:tw-py-2 tw-rounded-lg">
                <span className='tw-font-semibold tw-text-[10px] md:tw-text-sm'><span className="dot dot-medium"></span> {"Score 50% - < = 75%"}</span>
              </div>
              <div className="legend-item tw-flex tw-items-center tw-bg-green-100 tw-px-2 md:tw-px-4 tw-py-1 md:tw-py-2 tw-rounded-lg">
                <span className='tw-font-semibold tw-text-[10px] md:tw-text-sm'><span className="dot dot-good"></span>{"Score > 75%"}</span>
              </div>
            </div>

          </div>
          <div className="test-activity-tabs">
            <ul className="tabs-list">
              <li
                className={`tab-item ${toggletabs === 1 ? 'active' : ''}`}
                onClick={() => togglebutton(1)}
              >
                Completed Tests
              </li>
              <li
                className={`tab-item ${toggletabs === 0 ? 'active' : ''}`}
                onClick={() => togglebutton(0)}
              >
                Tests Pending
              </li>
            </ul>
          </div>

          <div className="test-activity-table-content">
            <div className="table-responsive">
              {!isLoading ?
                (dashdetails && dashdetails.length) ?
                  <CardDashboardIndex toggletabs={toggletabs} dashdetails={dashdetails} />
                  : (
                    <div className="no-data-section">
                      <img src={NoMocktestSvg} alt="NoMocktestSvg" />
                      <div className="no-data-message">
                        {/* No <span className="highlight">Mock Tests</span> added yet! <br />
                        Any new tests will appear here */}
                        {toggletabs === 1 ? 'You haven\'t completed any test yet!' : "No pending tests available!"}
                      </div>
                    </div>
                  )
                :
                <SkeletonCardDashboardIndex />}
            </div>
            {!isLoading && dashdetails && dashdetails.length > 0 && (
              <Paginator
                first={first}
                rows={rows}
                totalRecords={totalRecords}
                rowsPerPageOptions={[10, 20, 30]}
                onPageChange={onPageChange}
                className="custom-paginator"
                pageLinkSize={isMobile ? 2 : 5}
              />
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};